import DocList from '@/components/ui/doc-list/doc-list';
export default DocList;
